import React, { useEffect } from 'react';
import Homeslider from'./Homeslider';
import Suscestances from './Suscestances';
import TwosidesCards from './TwosidesCards';
import AerospaceanimatedCards from './AerospaceanimatedCards';
import Homewhatwedomobile from './Homewhatwedomobile';
// import EnrollPage from './EnrollPage'
import Homewhatwedo from './Homewhatwedo';
import Homepagedatacontent from './Homepagedatacontent';
import Footer from './Footer';
import Homeanimatedcardsmobile from './Homeanimatedcardsmobile';
const Home = () => {
     // Scroll to the top of the page when the component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []); // Empty dependency array ensures it only runs once when 

  return (
    <div style={{backgroundColor:'white'}}>
       <Homeslider/>
       {/* <Incrementcounternumber /> */}
       <Homewhatwedo />
       <Suscestances />
       {/* <Imagecroll /> */}
       <TwosidesCards />
     
      
       {/* <div className='home-wt-we-do'>
       <Homewhatwedomobile />
       </div> */}
       {/* <Homepagedatacontent /> */}
        <AerospaceanimatedCards  />
       {/* <AnalyticsCards /> */}
       {/* <NewCovered /> */}
       {/* <br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br> */}

       <div className='home-animated-cards'>
        <Homeanimatedcardsmobile />
       </div>
  
       <Footer />  
        {/* <style>
          {`
          h1,h2,h3,h4,h5,h6,p{
          font-family: urbanist , sarif;
          }
          `}
        </style> */}
        <style>
        {`
          body, h1, h2, h3, h4, h5, h6, p {
            font-family: "Helvetica Neue", sans-serif !important;
          }
        `}
      </style>
    </div>
  )
}

export default Home